import loadable from '@loadable/component';
import React from 'react';
import { connect } from 'react-redux';
import {
    clickOnOnlineCollection,
    clickOnTransitionOnlineCollection,
} from '../../redux/content';

const CollectionsBucket = loadable(
    () => import('../../../../components/FeaturedCollections'),
    { resolveComponent: (components: any) => components.CollectionsBucket },
);

interface CollectionsBucketContainerProps {
    placeId?: string;
    isFeLoading?: boolean;
    collections?: object;
    trackGAEventOnPageUnload?: () => void;
    trackGAEvent?: () => void;
    tabKey?: string;
    tld?: string;
}

const CollectionsBucketContainer = (props: CollectionsBucketContainerProps) => {
    const {
        isFeLoading,
        trackGAEvent,
        trackGAEventOnPageUnload,
        tld,
        placeId,
    } = props;

    let bucketContent = null;

    if (!isFeLoading) {
        bucketContent = (
            <CollectionsBucket
                tld={tld}
                currentPlace={placeId || 'online'}
                trackGAEvent={trackGAEvent}
                trackGAEventOnPageUnload={trackGAEventOnPageUnload}
            />
        );
    }

    return bucketContent;
};

const _mapStateToProps = ({
    app,
    location,
}: {
    app: {
        loadingState?: { isFeLoading?: boolean };
        isBotRequest?: boolean;
        tld?: string;
    };
    location: {
        placeId?: string;
    };
}) => ({
    isFeLoading: app.loadingState && app.loadingState.isFeLoading,
    isBotRequest: app.isBotRequest,
    placeId: location.placeId,
    tld: app.tld,
});

const _mapDispatchToProps = {
    trackGAEventOnPageUnload: clickOnOnlineCollection,
    trackGAEvent: clickOnTransitionOnlineCollection,
};

export default connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(CollectionsBucketContainer);
